import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useLocalePath } from '#imports'
import useAuth from '~/composables/auth/useAuth'

export default defineNuxtRouteMiddleware(async () => {
  // SSR skip - cookies seems to not be functioning in ssr
  if (import.meta.server) {
    return
  }

  const localePath = useLocalePath()
  const { checkAuthStatus } = useAuth()

  // Check auth status without auto-redirect
  const isAuthenticated = await checkAuthStatus()

  // Redirect only if user is actually authenticated
  if (isAuthenticated) {
    return navigateTo(localePath('/account'), { external: true })
  }
})
